import React, { useState, useEffect, useMemo } from "react";
import { formatCurrency } from "../helpers/currencyHelpers";
import './DealHeader.scss'
import { IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { baseUrl } from "../helpers/configHelper";
import { inlineBrandImage } from "../helpers/menuHelpers";

interface DealComponentProps {
    primaryDefaultText: string;
    primarySelectedText: string;
    selected?: string;
}

function DealComponent(props: DealComponentProps) {
    const [imageFailed, setImageFailed] = useState(false);

    useEffect(() => {
        setImageFailed(false);
    }, [props.selected]);

    return (
        <div className={`deal-component ${props.selected ? 'selected' : ''}`}>
            {props.selected !== undefined
                ?
                <>
                    {props.selected && !imageFailed
                        ?
                        <img
                            alt=""
                            src={`${baseUrl()}/images/ProductShots/${props.selected}.png`}
                            onError={() => setImageFailed(true)}
                        />
                        :
                        <p>{props.primarySelectedText}</p>
                    }
                </>
                :
                <p>{props.primaryDefaultText}</p>
            }
        </div>
    )
}

function DealGraphic() {
    const menuItem = useSelector((state: ApplicationState) => state.menuItemData?.menuItem);

    const mainItemImage = useMemo(() => {
        var image = menuItem?.overrideMenuItemImageInDealComponents ?? `${menuItem?.sku}_PDP`;

        if (menuItem?.productNameBasketOverride && menuItem?.showMenuItemImageInDealComponents) {
            return image;
        }

        return null;
    }, [menuItem]);

    const filteredModifierGroups = useMemo(() => {
        return menuItem?.modifierGroups
            ?.filter((v: IMopModifierGroup) => {
                return v.primaryModifierGroup;
            })
            ?.sort((a: IMopModifierGroup, b: IMopModifierGroup) => {
                return a.showOnPage - b.showOnPage || a.order - b.order;
            })
    }, [menuItem]);

    const totalModifierGroups = useMemo(() => {
        return menuItem?.modifierGroups.filter((v: IMopModifierGroup) => v.primaryModifierGroup).length ?? 0
    }, [menuItem]);

    function getSelected(mg: IMopModifierGroup): string | undefined {
        const selected = mg.modifierGroupItems.find((v: IMopModifierGroupItem) => {
            return v.quantitySelected > 0;
        });

        return selected?.sku;
    }

    return (
        <div className='deal-header-graphic'>
            {mainItemImage &&
                <>
                    <DealComponent
                        primaryDefaultText={menuItem?.menuItemName ?? ''}
                        primarySelectedText={menuItem?.menuItemName ?? ''}
                        selected={mainItemImage}
                    />
                    <IonIcon icon={add} />
                </>
            }
            {filteredModifierGroups?.map((v: IMopModifierGroup, index: number) => {
                    let selected = getSelected(v);

                    return (
                        <>
                            <DealComponent
                                primaryDefaultText={v.primaryDefaultText}
                                primarySelectedText={v.primarySelectedText}
                                selected={selected ? `${selected}_PDP` : undefined}
                            />
                            {index + 1 < (totalModifierGroups ?? 0) &&
                                <IonIcon icon={add} />
                            }
                        </>
                    )
                })
            }
        </div>
    );
}

interface DealHeaderProps {
    menuItem?: IMopMenuItemDetail;
}

function DealHeader(props: DealHeaderProps) {
    const dealIndex = props.menuItem?.menuItemName.indexOf('Deal');
    const isDeal = dealIndex !== -1;

    return (
        <div className="deal-header">
            <div className='banner'>
                <p>
                    <span className="bold" dangerouslySetInnerHTML={{__html: inlineBrandImage(props.menuItem?.menuItemName.substr(0, isDeal ? dealIndex : undefined) ?? "", props.menuItem?.hasBrandImage ?? false)}}>
                    </span>
                    {isDeal &&
                        ' Deal'
                    }
                    <span className="banner-price bold">
                        {` ${formatCurrency(props.menuItem?.menuItemBasePrice)}`}
                    </span>
                </p>
            </div>
            <DealGraphic />
        </div>
    );
}

export default DealHeader;
